import type { QueryKey } from "@tanstack/react-query";

/** Query-key factory for broker leads (dealKeys-style). Every lead read
 * registers under the `leadKeys.all` prefix so a mutation can cover
 * detail + list + stats with ONE prefix invalidation. */
export const leadKeys = {
  all: ["leads"] as const,
  list: (filters: Record<string, unknown>): QueryKey => [...leadKeys.all, "list", filters],
  stats: (filters: Record<string, unknown>): QueryKey => [...leadKeys.all, "stats", filters],
  detail: (id: string) => [...leadKeys.all, "detail", id] as const,
  // Lead Generation — active-generator options for the Ownership picker.
  generatorOptions: (q: string) => [...leadKeys.all, "generator-options", q] as const,
};
